import React, { useState, useEffect, useCallback } from "react";
import { BaseModal } from "newcar-ui/output/es/components/AskpricePublicModal";
import { tools } from "newcar-ui/output/es/utils";
import BetterScroll from "better-scroll";
let bs;// eslint-disable-line
window.localList = [];
const TopSlotNode = React.memo((props) => {
  return (
    <div className="top-slot-node">
      <div className="modal-subtitle">
        您看的这款车已停售，给您推荐同级车，欢迎咨询
      </div>
      <div className="car-list">
        <div className="car-list-wrap">
          {props.carList &&
            props.carList.map((item, index) => {
              return (
                <div
                  className="car-item-wrap"
                  id={`id${index}`}
                  data-index={index}
                  data-lineid={item.id}
                  key={index}
                >
                  <div className="car-item-top">
                    <img
                      src={
                        item.guidePic ||
                        "//img2.xgo-img.com.cn/line_head_big/9/240x180/60740d157bbd8.png"
                      }
                    />
                  </div>
                  <div className="car-item-bottom">
                    <div className="car-type-name">{item.name || ""}</div>
                    <div className="car-type-info">{item.subTitle || ""}</div>
                    <div className="car-type-price">
                      {item.guidePrice || ""}
                    </div>
                    <div
                      className={`car-type-check`}
                      id={`check${index}`}
                    ></div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
});
const Index = () => {
  /** 车型信息 */
  const [ajaxParams, setAjaxParams] = useState({
    multiProductId: "",
    multiLineId: "",
  });
  const [carList, setCarList] = useState([]);
  const [ids, setIds] = useState("");
  const [fCode, setFCode] = useState("115");
  const [listType, setListType] = useState("115");
  /** 城市信息 */
  const [cityInfo, setCityInfo] = useState({
    cityid: 613,
    cityname: "北京",
  });
  /** 查成交价弹窗显示 */
  const [showFinalPriceModal, setShowFinalPriceModal] = useState(false);
  const itemClick = useCallback((e) => {
    let target = e.currentTarget;
    let index = e.currentTarget.getAttribute("data-index");
    let check = document.getElementById(`check${index}`);
    let lineid = e.currentTarget.getAttribute("data-lineid");
    if (localList[index]) {
      // 如果选中
      localList[index] = "";
      let ids_ = [];
      for (let i = 0; i < localList.length; i++) {
        if (localList[i] != "") {
          ids_.push(localList[i]);
        }
      }
      setIds(ids_.join(","));
      check.setAttribute("style", "display:none;");
      target.setAttribute("style", "");
    } else {
      // 取消
      localList[index] = lineid;
      let ids_ = [];
      for (let i = 0; i < localList.length; i++) {
        if (localList[i] != "") {
          ids_.push(localList[i]);
        }
      }
      setIds(ids_.join(","));
      check.setAttribute("style", "display:block;");
      target.setAttribute(
        "style",
        "background: linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(253,85,47,0.08) 100%);"
      );
    }
  }, []);
  useEffect(() => {
    if (typeof window.getCity !== "undefined") {
      window.getCity((res) => {
        setCityInfo({
          cityid: res.cityid,
          cityname: res.name,
        });
      });
    }

    window.showLineModalAskPrice = onShowFinalPriceModal;
  }, []);
  useEffect(() => {
    if (showFinalPriceModal) {
      // 初始化滚动条
      setTimeout(() => {
        bs = new BetterScroll(".car-list", {
          scrollX: true,
          scrollY: false,
          bounce: false,
          click: true,
          stopPropagation: true,
        });
      }, 10);
      setTimeout(() => {
        // 第一次进来
        localList = [];
        let listItem = window.document.getElementsByClassName("car-item-wrap");
        for (let i = 0; i < listItem.length; i++) {
          if (i == 0) {
            // 默认选中第一个
            localList[0] = listItem[i].getAttribute("data-lineid");
            setIds(localList[0]);
            let check = document.getElementById(`check${0}`);
            check.setAttribute("style", "display:block;");
            listItem[i].setAttribute(
              "style",
              "background: linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(253,85,47,0.08) 100%);"
            );
          }
          // 循环绑定事件
          listItem[i].addEventListener("click", itemClick);
        }
      }, 1000);
    }
  }, [showFinalPriceModal]);
  /** 显示查成交价弹窗 */
  const onShowFinalPriceModal = useCallback((from, lineId, productId) => {
    tools
      .request(
        "//service.58che.com/unify/v1/recommendpopup/",
        { productId: productId || "", lineId: lineId || "2421" },
        "jsonp",
        { method: "get" }
      )
      .then(
        (res) => {
          let list = res.entity.data.list;
          setCarList(list);
          from && setFCode(from);
          setListType(res.entity.data.listType);
          setShowFinalPriceModal(true);
        },
        (error) => {
          console.log("error:", error);
        }
      );
  }, []);
  const onCloseFinalPriceModal = useCallback(() => {
    // let listItem = window.document.getElementsByClassName('car-item-wrap');
    // for(let i = 0;i<listItem.length;i++){
    //   listItem[i].removeEventListener("click",itemClick);
    //   window.localList = [];
    // }
    setShowFinalPriceModal(false);
  }, []);
  useEffect(() => {
    if (listType == 1) {
      setAjaxParams({ multiProductId: "", multiLineId: ids });
    } else if (listType == 2) {
      setAjaxParams({ multiProductId: ids, multiLineId: "" });
    }
  }, [listType, ids]);
  return (
    <div>
      <BaseModal
        visible={showFinalPriceModal}
        topSlotNode={
          showFinalPriceModal ? <TopSlotNode carList={carList} /> : null
        }
        closeFun={onCloseFinalPriceModal}
        fCode={fCode}
        prodInfoRelate={{
          showProdArea: false,
          productId: "",
          lineId: "",
        }}
        titleRelate={{
          mainTitle: "推荐车型咨询",
        }}
        contentCn={"linecars"}
        modalCn="newcar-modal-wrap "
        cityinfoRelate={{
          show: true,
          defaultCityInfo: {
            cityid: cityInfo.cityid,
            cityname: cityInfo.cityname,
          },
        }}
        submitRelate={{
          ajaxParams: ajaxParams,
        }}
      />
    </div>
  );
};

export default Index;
